export default __webpack_public_path__ + "static/section2-renovation-7175ff1a8ba7b68e7696d9beb4cebc24.webp";